import { t } from 'i18next';

import { PageLayout } from 'coreOld/components';
import { SystemSettings } from 'system/components';

const SystemSettingsPage = () => {
  return (
    <PageLayout title={t('labelSystemSettings')}>
      <SystemSettings />
    </PageLayout>
  );
};

export default SystemSettingsPage;
